import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ContactForm from 'containers/ContactModal/ContactFormContainer';
import MeetingForm from 'containers/ContactModal/MeetingFormContainer';
import DeleteCont from 'containers/ContactModal/DeleteContactContainer';
import classes from './ContactModal.module.scss';

const messages = defineMessages({
  deleteSubLabel: {
    id: 'components.contactModal.deleteSubLabel',
    defaultMessage: 'Are you sure you want to delete {name}?'
  },
  createMeeting: {
    id: 'components.contactModal.createMeeting.label',
    defaultMessage: 'Create a Meeting'
  },
  createMeetingSubLabel: {
    id: 'components.contactModal.createMeeting.subLabel',
    defaultMessage: 'Cloud-based meeting rooms are available 24/7.'
  },
  editMeeting: {
    id: 'components.contactModal.editMeeting.label',
    defaultMessage: 'Edit Meeting'
  },
  deleteMeeting: {
    id: 'components.contactModal.deleteMeeting.label',
    defaultMessage: 'Delete Meeting?'
  },
  createContact: {
    id: 'components.contacts.contactModal.label',
    defaultMessage: 'Add a Contact'
  },
  editContact: {
    id: 'components.contacts.editContact.label',
    defaultMessage: 'Edit Contact'
  },
  deleteContact: {
    id: 'components.contacts.deleteContact.label',
    defaultMessage: 'Delete Contact?'
  }
});

const renderForm = (isMeeting, isCreate, contactObj) => {
  if (isMeeting) {
    return (
      <MeetingForm
        contactObj={contactObj}
        isCreate={isCreate}
      />
    );
  }

  return (<ContactForm isCreate={isCreate} />);
};

const defaultLayout =
    (titleLabel, titleSubLabel, isMeeting, isCreate, contactObj) =>
      <div
        className={`${classes.container} ${isMeeting ? classes.isMeeting : ''}`}
      >
        <header>
          <h1 className={classes.createContactLabel}>
            {titleLabel}
          </h1>
          {titleSubLabel ? <h6 className={`${classes.subLabel}`}>
            {titleSubLabel}
          </h6> : null }
        </header>
        {renderForm(isMeeting, isCreate, contactObj)}
      </div>;

const deleteLayout = (titleLabel, deleteMessage) =>
  <div className={`${classes.container} ${classes.isDelete}`}>
    <header>
      <h1>
        {titleLabel}
      </h1>
      <h6>
        {deleteMessage}
      </h6>
    </header>
    <DeleteCont />
  </div>;

export class ContactModal extends React.PureComponent {
  getTitleLabel = () => {
    if (this.props.isMeeting) {
      if (this.props.isDelete) {
        return this.props.intl.formatMessage(messages.deleteMeeting);
      } else if (this.props.isCreate) {
        return this.props.intl.formatMessage(messages.createMeeting);
      }
      return this.props.intl.formatMessage(messages.editMeeting);
    }
    if (this.props.isDelete) {
      return this.props.intl.formatMessage(messages.deleteContact);
    } else if (this.props.isCreate) {
      return this.props.intl.formatMessage(messages.createContact);
    }
    return this.props.intl.formatMessage(messages.editContact);
  };

  getTitleSubLabel = () => {
    return null;
  };

  getLayout = () => {
    if (this.props.isDelete) {
      return deleteLayout(
        this.getTitleLabel(),
        this.props.intl.formatMessage(messages.deleteSubLabel, { name: this.props.contactObj.name })
      );
    }

    return defaultLayout(
      this.getTitleLabel(),
      this.getTitleSubLabel(),
      this.props.isMeeting,
      this.props.isCreate,
      this.props.createdMeeting,
      this.props.contactObj
    );
  };

  render() {
    return (this.getLayout());
  }
}

ContactModal.propTypes = {
  contactObj: PT.object,
  isDelete: PT.bool,
  isMeeting: PT.bool,
  isCreate: PT.bool,
  intl: PT.object.isRequired
};

export default injectIntl(ContactModal);
